
require('../sass/blank.scss')
window.fuse = require('fuse.js');
require("waypoints/lib/noframework.waypoints.js")

//import "sma"
//import "highlight.js"
require( './vendor/smart-underline.js')
require( './inc/classes.js')
//require( 'vanillatop')
import debounce from './inc/debounce'
import { Validation } from 'bunnyjs/src/Validation'


/**
 * Lukaswhite.com JS file
 */
let Site = {
    init : function() {

        document.querySelector('.mobile-top').classList.remove('intially-hidden');

        if (document.getElementById("contact")) {
            import("./init-contact" /* webpackChunkName: "contact" */).then(m => {            
                m.initContact()
            });
        }

        if (document.getElementById("search")) {
            import("./init-search" /* webpackChunkName: "search" */).then(m => {
                m.initSearch( )
            });
        }

        /**
         * Fastclick
         */
        if ('addEventListener' in document) {
            document.addEventListener('DOMContentLoaded', function() {
                const attachFastClick = require('fastclick');
                //attachFastClick(document.body);
            }, false);
        }

        document.addEventListener('click', function (event) {
            if (!event.target.matches('.mobile-nav-btn')) return;
            event.preventDefault();
            let drawer = document.querySelector('.drawer')
            drawer.classList.toggle('active');
            event.stopPropagation()

        }, false);

        // Close mobile nav on window resize
        let winResize = debounce(function() {
            document.querySelector('.drawer').classList.remove('active');
            //document.querySelector('.mobile-nav').classList.remove('expanded');
        }, 250);

        window.addEventListener('resize', winResize);

        /**
         * Smart underline
         */
        SmartUnderline.init({
            location: ''
        });

        /**
         * Dynamic nav
         */
        if ( document.getElementById('hero')) {
            var mainNav = document.getElementById('main-nav');

            var navWP = new Waypoint({
                element: document.getElementById('hero'),
                handler: function(direction) {
                    if ( direction === 'down' ) {
                        $('#main-nav').addClass('scrolled');
                        $('#mobile-nav').addClass('scrolled');
                        //removeClass( mainNav, 'with-hero' );
                    } else {
                        $('#main-nav').removeClass('scrolled');
                        $('#mobile-nav').removeClass('scrolled');
                        //addClass( mainNav, 'with-hero' );
                    }
                },
                offset: -50
            });
        }

        function scrollTo(element, to, duration) {
            if (duration <= 0) return;
            var difference = to - element.scrollTop;
            var perTick = difference / duration * 10;

            setTimeout(function() {
                element.scrollTop = element.scrollTop + perTick;
                if (element.scrollTop == to) return;
                scrollTo(element, to, duration - 10);
            }, 10);
        }

        var footerWP = new Waypoint({
            element: document.getElementById('page-footer'),
            handler: function(direction) {
                if ( direction === 'down' ) {
                    $('#to-top').removeClass('hidden');
                } else {
                    $('#to-top').addClass('hidden');
                }
            },
            offset: 500
        });


        function backToTop() {
            if (window.pageYOffset > 0) {
                window.scrollBy(0, -80);
                setTimeout(backToTop, 0);
            }
        }

        

        document.getElementById('to-top').addEventListener(
            'click',
            function( e ) {
                backToTop()
                e.preventDefault();
            }
        );

    },
    initHomepage : function() {

    }
}

window.Contact = {
    init : function() {
        Validation.lang.required = 'This field is required'
        Validation.init(document.forms[0], true);
    },
    recaptchaCallback: ( r ) => {
        console.log( 'recaptcha callback' )
        console.log( r )
    }
}

window.recaptchaCallback = ( r ) => {
    console.log( 'recaptcha callback 2' )
    console.log( r )
    document.getElementById('captcha-response').value = r
}

var Blog = {
    initShow : function() {

        var bodyEditor = new TINY.editor.edit('editor',{
            id:'blog-comments-form-body', // (required) ID of the textarea
            cssclass:'te', // (optional) CSS class of the editor
            controlclass:'tecontrol', // (optional) CSS class of the buttons
            rowclass:'teheader', // (optional) CSS class of the button rows
            dividerclass:'tedivider', // (optional) CSS class of the button diviers
            controls:['bold', 'italic', '|', 'image', 'link', 'unlink'],
            footer:false,
            //fonts:['Verdana','Arial','Georgia','Trebuchet MS'],  // (optional) array of fonts to display
            xhtml:true, // (optional) generate XHTML vs HTML
            //cssfile:'style.css', // (optional) attach an external CSS file to the editor
            //css:'body{background-color:#ccc}', // (optional) attach CSS to the editor
            bodyid:'editor', // (optional) attach an ID to the editor body
            footerclass:'tefooter', // (optional) CSS class of the footer
            toggle:{text:'source',activetext:'wysiwyg',cssclass:'toggle'}, // (optional) toggle to markup view options
            resize:{cssclass:'resize'} // (optional) display options for the editor resize
        });

        var commentForm = new Inspect(
            {
                'form' : 'blog-comments',
                'editors' : [ bodyEditor ]
            }
        );
        commentForm.toSubmit();




    }
}

Site.init();